/* eslint-disable */
import React, { useEffect, useState } from "react";
import JoditEditor from "jodit-react";
import { useLocation, useParams } from "react-router";
import { PUBLISH_BLOG_SHOPIFY, PUBLISH_BLOG_WORDPRESS } from "../../gql/mutations/userWebSiteVisit";
import { SCHEDULE_POST } from "../../gql/mutations/scrapy";
import { useMutation } from "@apollo/client";
import {
  Box, Button, Card, CircularProgress, Container, Dialog, DialogActions,
  DialogContent, DialogTitle, Divider, Grid, IconButton, Typography, styled, useTheme,
} from "@mui/material";
import { Close as CloseIcon, Schedule as ScheduleIcon } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { usePopup } from "../../context/commonPop";
import { GetProjectByUserId } from "../../hooks/userWebsiteData";
import { useSelector } from "react-redux";
import SchemaGeneratorModal from "../ai/SchemaGeneratorModal";

const SectionWrapper = styled("section")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: "30px 0",
  paddingTop: "0",
  "& .MainHeading": {
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: "20px",
  },
  "& .BtnWrapper": {
    textAlign: "left",
  },
}));

function EditBlog() {
  const theme = useTheme();
  const customizer = useSelector(state => state.customizer);
  const { handleOpen } = usePopup();
  const { projectId } = useParams();
  const location = useLocation();
  const {
    state: { htmlData, heading },
  } = location;

  const [content, setContent] = useState("");
  const { allProjectWithSessionId } = GetProjectByUserId({ RequireSessionId: 1 });
  const [publishBlogShopify] = useMutation(PUBLISH_BLOG_SHOPIFY);
  const [publishBlogWordpress] = useMutation(PUBLISH_BLOG_WORDPRESS);
  const [schedulePost, { loading: scheduling }] = useMutation(SCHEDULE_POST);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const [schemaOpen, setSchemaOpen] = useState(false);
  const [scheduledAt, setScheduledAt] = useState(dayjs().add(1, "hour"));
  const projectData = allProjectWithSessionId.find(project => project.id === projectId);

  useEffect(() => {
    if (htmlData && typeof htmlData === "object" && htmlData.text_html) {
      const trimmedContent = htmlData.text_html.trim().replace(/\n/g, "");
      setContent(trimmedContent);
    } else {
      setContent("");
    }
  }, [htmlData]);

  const handlePublish = async () => {
    try {
      const filteredProject = allProjectWithSessionId.find(project => project.id === projectId);
      if (!filteredProject) {
        console.error("Project not found");
        return;
      }

      const { appType, website } = filteredProject;
      if (appType === "Shopify") {
        const { data } = await publishBlogShopify({
          variables: {
            inputdata: {
              body: htmlData?.text_html,
              description: "Testing Description For Blog Upload",
              projectId,
              title: heading,
            },
          },
        });
        if (data) {
          handleOpen(true, "Blog Published Successfully");
        }
       
      } else if (appType === "Wordpress") {
        const { data } = await publishBlogWordpress({
          variables: {
            inputdata: {
              body: htmlData?.text_html,
              description: "Testing Description For Blog Upload",
              projectId,
              domain: website,
              title: heading,
            },
          },
        });
        if (data) {
          handleOpen(true, "Blog Published Successfully");
        }
      } else {
        console.error("Unsupported apptype:", appType);
      }
    } catch (error) {
      console.error("Error publishing blog:", error);
    }
  };

  const handleSchedule = async () => {
    if (!scheduledAt || !scheduledAt.isValid() || scheduledAt.isBefore(dayjs())) {
      handleOpen(false, "Please select a future date and time");
      return;
    }
    try {
      await schedulePost({
        variables: {
          input: {
            projectId,
            title: heading,
            body: content,
            description: "",
            publishAt: scheduledAt.toISOString(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        },
      });
      handleOpen(true, "Blog scheduled successfully");
      setScheduleOpen(false);
    } catch (error) {
      handleOpen(false, error.message || "Failed to schedule blog");
    }
  };

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Card
            sx={{ padding: { xs: "15px 15px 50px 15px", sm: "30px 45px 40px 40px" }, border: `1px solid ${theme.palette.divider}` }}
            elevation={customizer.isCardShadow ? 9 : 0}
            variant={!customizer.isCardShadow ? "outlined" : undefined}
          >
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} md={6}>
                <Typography component="h2" className="MainHeading">
                  Edit Your Blog
                </Typography>
                <JoditEditor value={content} onChange={newContent => setContent(newContent)} tabIndex={1} />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography component="h2" className="MainHeading">
                  Preview Your Blog
                </Typography>
                <JoditEditor value={content} onChange={newContent => setContent(newContent)} tabIndex={1} />
              </Grid>
              <Grid item xs={12} md={12}>
                <Box className="BtnWrapper" sx={{ display: "flex", gap: 1 }}>
                  <Button onClick={handlePublish} variant="contained">
                    Publish
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<ScheduleIcon />}
                    onClick={() => setScheduleOpen(true)}
                    sx={{ textTransform: "none" }}
                  >
                    Schedule
                  </Button>
                  <Button variant="outlined" onClick={() => setSchemaOpen(true)} sx={{ textTransform: "none" }}>
                    Generate Schema
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>

      {/* Schedule Dialog */}
      <Dialog
        open={scheduleOpen}
        onClose={() => setScheduleOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px" } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <ScheduleIcon color="primary" fontSize="small" />
              <Typography variant="h6" fontWeight={700}>Schedule Post</Typography>
            </Box>
            <IconButton onClick={() => setScheduleOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 3 }}>
          <Box mb={2}>
            <Typography variant="caption" color="text.secondary" display="block">Post Title</Typography>
            <Typography variant="subtitle2" fontWeight={600}>{heading}</Typography>
            {projectData && (
              <Typography variant="caption" color="text.secondary">
                {projectData.projectName || projectData.website} ({projectData.appType})
              </Typography>
            )}
          </Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Publish Date & Time"
              value={scheduledAt}
              onChange={(val) => setScheduledAt(val)}
              disablePast
              slotProps={{
                textField: {
                  fullWidth: true,
                  helperText: `Timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
                },
              }}
            />
          </LocalizationProvider>
          {scheduledAt && scheduledAt.isValid() && scheduledAt.isAfter(dayjs()) && (
            <Box mt={2} sx={{ backgroundColor: theme.palette.primary.light + "15", borderRadius: "8px", p: 1.5, border: `1px solid ${theme.palette.primary.light}` }}>
              <Typography variant="body2" color="primary.main" fontWeight={500}>
                Will publish on {scheduledAt.format("dddd, MMMM D, YYYY [at] h:mm A")}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setScheduleOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSchedule}
            disabled={scheduling}
            startIcon={scheduling ? <CircularProgress size={16} /> : null}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: "8px" }}
          >
            {scheduling ? "Scheduling..." : "Schedule Post"}
          </Button>
        </DialogActions>
      </Dialog>

      <SchemaGeneratorModal open={schemaOpen} onClose={() => setSchemaOpen(false)} sessionId={projectData?.srapySessionData?.[0]?.sessionId} url={projectData?.website} />
    </SectionWrapper>
  );
}

export default EditBlog;
